import { Injectable } from '@angular/core';
import { TenantSourceService } from './tenant-source.service';
import { ConnectionTypesService } from './connection-types.service';
import { combineLatest, firstValueFrom, map, Observable } from 'rxjs';
import { ConnectionType } from 'src/app/shared/models/connection-type';
import { TenantSource } from 'src/app/shared/models/tenant-source';

@Injectable({
    providedIn: 'root'
})
export class TenantSourceWithConnectionService {
    constructor(
        private sourceService: TenantSourceService,
        private connectionTypeService: ConnectionTypesService
    ) {}

    getTenantSourceWithConnection(tenantId: string, sourceId: number): Observable<TenantSource> {
        return combineLatest([
            this.sourceService.getTenantSource(tenantId, sourceId),
            this.connectionTypeService.getConnectionTypes()
        ]).pipe(
            map(([source, connectionTypes]) => {
                const type = connectionTypes.find((ct: ConnectionType) => ct.connectionType === source.connectionType);
                return { ...source, connectionFamily: type ? type.connectionFamily : null };
            })
        );
    }

    getTenantSourcesWithConnection(tenantId: string): Observable<TenantSource[]> {
        return combineLatest([
            this.sourceService.getTenantSources(tenantId),
            this.connectionTypeService.getConnectionTypes()
        ]).pipe(
            map(([sources, connectionTypes]) => {
                return sources.map(source => {
                    const type = connectionTypes.find(
                        (ct: ConnectionType) => ct.connectionType === source.connectionType
                    );
                    return { ...source, connectionFamily: type ? type.connectionFamily : null };
                });
            })
        );
    }

    getCachedTenantSourcesWithConnection(tenantId: string): Promise<Array<TenantSource>> {
        return firstValueFrom(
            combineLatest([
                this.sourceService.getCachedTenantSources(tenantId),
                this.connectionTypeService.getConnectionTypes()
            ]).pipe(
                map(([sources, connectionTypes]) => {
                    return sources.map(source => {
                        const type = connectionTypes.find(
                            (ct: ConnectionType) => ct.connectionType === source.connectionType
                        );
                        return { ...source, connectionFamily: type ? type.connectionFamily : null };
                    });
                })
            )
        );
    }
}
